import React from 'react';
import Modal from 'react-bootstrap4-modal';

export default function Dialog({
                                   open,
                                   children,
                                   title,
                                   footer
                               }) {
    return (
        <Modal visible={open} dialogClassName='modal-dialog-centered' fade={true}>
            <div className="modal-header">
                <h2 className="modal-title">{title}</h2>
            </div>
            <div className="modal-body">
                {children}
            </div>
            <div className="modal-footer">
                {footer}
            </div>
        </Modal>
    );
}
